export const searchDefaults = {
    placeholder: "Zoeken",
    moreResults: "Meer resultaten",
};
export default searchDefaults;
